import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import LazyLoad from 'react-lazy-load';

import { Divider, LText, Button, Spacer } from '@lafabrica/core';
import { DownArrow } from '../DownArrow';

const Wrapper = styled.div`
  min-height: calc(100vh - 50px);
  height: auto;
  width: 100vw;
  display: flex;
  flex-direction: row;
  padding-top: 50px;
  ${props => props.backgroundImage &&
    `background-image: url(${props.backgroundImage});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    `
  }

  @media only screen and (min-width: 769px) {
    min-height: calc(100vh - 80px);
    padding-top: 80px;
  }
`;

const Overlay = styled.div`
  ${props =>
    `background-color: ${props.overlayColor};
    opacity: ${props.overlayOpacity};
    `
  }

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;

  @media only screen and (min-width: 769px) {
    min-height: 700px;
  }
`

const InnerWrapper = styled.div`
  padding: 0 40px;
  margin: auto;
  text-align: center;
  z-index: 1;

  @media only screen and (min-width: 769px) {
    width: 600px;
  }
`;

const DownArrowContainer = styled.div`
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-items: center;
`

export const OpeningPanelImage = ({children, backgroundImage, backgroundStyle={}, showDownArrow=false, overlay=false, overlayOpacity=0.6, overlayColor='var(--white)'}) => {

  return (
    <Wrapper style={isMobile ? {flexDirection: 'column', ...backgroundStyle} : backgroundStyle} backgroundImage={backgroundImage}>

      <InnerWrapper>
        {children}
      </InnerWrapper>
      {showDownArrow &&
        <DownArrowContainer>
          <DownArrow color={"var(--black)"}/>
        </DownArrowContainer>
      }
      {overlay &&
        <Overlay overlayOpacity={overlayOpacity} overlayColor={overlayColor}/>
      }
    </Wrapper>
  );
};
